module.exports = __webpack_public_path__ + "img/first-plate.8ef5373a.png";